module.exports = __webpack_public_path__ + "static/media/drink_selection.37b5e66d.svg";